import { render, staticRenderFns } from "./PlateOwners.vue?vue&type=template&id=3ef653f1"
import script from "./PlateOwners.vue?vue&type=script&lang=js"
export * from "./PlateOwners.vue?vue&type=script&lang=js"
import style0 from "./PlateOwners.vue?vue&type=style&index=0&id=3ef653f1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports